import React, { Component } from 'react';
import { Dropdown, DropdownProps } from 'primereact/dropdown';
import LanguageUtil from '../../util/LanguageUtil';

class IntervalDropDown extends Component<Props> {
  render() {
    const options: { label: string; value: DurationUnit }[] = [
      {
        label: LanguageUtil.get({ id: 'common.label.minute', defaultMessage: 'Minute' }),
        value: 'minute',
      },
      {
        label: LanguageUtil.get({ id: 'common.label.hour', defaultMessage: 'Hour' }),
        value: 'hour',
      },
      {
        label: LanguageUtil.get({ id: 'common.label.day', defaultMessage: 'Day' }),
        value: 'day',
      },
      {
        label: LanguageUtil.get({ id: 'common.label.week', defaultMessage: 'Week' }),
        value: 'week',
      },
      {
        label: LanguageUtil.get({ id: 'common.label.month', defaultMessage: 'Month' }),
        value: 'month',
      },
      {
        label: LanguageUtil.get({ id: 'common.label.year', defaultMessage: 'Year' }),
        value: 'year',
      },
    ];
    const { ...rest } = this.props;
    return (
      <div onClick={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()} className='w-full !h-[34px] text-left'>
        <Dropdown className='!bg-white w-full !h-[34px] !border-[0.5px] !border-f-black-4' options={options} itemTemplate={this.optionTemplate} {...rest} />
      </div>
    );
  }

  private optionTemplate = (option: { label: string; value: string }) => {
    return (
      <div className='flex items-center gap-x-2 !h-[28px] text-md ' data-testid={`select-item-${option.value}`}>
        {option.label}
      </div>
    );
  };
}

interface Props extends DropdownProps {
  'data-testid'?: string;
}

export type DurationUnit = 'millisecond' | 'second' | 'minute' | 'hour' | 'day' | 'week' | 'month' | 'year';

export default IntervalDropDown;
